module.exports = __webpack_public_path__ + "a5df1f072646af4d9420e8a89bde4da4.png";